import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { UserSessionService } from '../../services/user-session.service';
import { API_BASE_URL } from '../../services/api-base';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})

export class HomeComponent implements OnInit {

  userName = '';
  avatarUrl: string | null = null;
  currentUser: any = null;
  uploadError = '';
  isUploading = false;
  @ViewChild('avatarInput') avatarInput?: ElementRef<HTMLInputElement>;
  private readonly apiBase = `${API_BASE_URL}`;

  constructor(
    private userService: UserService,
    private userSession: UserSessionService,
    private router: Router
  ) {}

  ngOnInit(){
    this.router.navigate(['/feed'], { replaceUrl: true });
    this.currentUser = this.userSession.getUser();
    if (this.currentUser) {
      this.userName = this.currentUser?.name || this.currentUser?.email || '';
      this.avatarUrl = this.buildAvatarUrl(this.currentUser?.picture_user);
    } else {
      this.userName = '';
      this.avatarUrl = null;
    }
  }

  triggerAvatarUpload() {
    this.avatarInput?.nativeElement.click();
  }

  onAvatarSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) {
      return;
    }

    const file = input.files[0];
    if (!this.currentUser?.id) {
      return;
    }

    this.isUploading = true;
    this.uploadError = '';

    this.userService.uploadAvatar(this.currentUser.id, file).subscribe({
      next: (res) => {
        this.isUploading = false;
        const url = this.buildAvatarUrl(res.picture_url);
        this.avatarUrl = url;
        this.persistUser({
          picture_user: res.picture_url
        });
      },
      error: (err) => {
        this.isUploading = false;
        this.uploadError = err?.error?.error || 'Não foi possível atualizar a foto.';
      }
    });

    input.value = '';
  }

  private buildAvatarUrl(pathValue?: string | null) {
    if (!pathValue) {
      return null;
    }
    if (pathValue.startsWith('http')) {
      return pathValue;
    }
    return `${this.apiBase}${pathValue}`;
  }

  private persistUser(partial: any) {
    const updated = this.userSession.patchUser(partial);
    if (updated) {
      this.currentUser = updated;
    }
  }

}
